import { Link } from 'react-router-dom';

interface FooterProps {
  variant?: 'default' | 'legal';
}

export const Footer = ({ variant = 'default' }: FooterProps) => {
  const isLegal = variant === 'legal';

  return (
    <footer
      className={`
        w-full border-t border-gray-200 bg-white mt-auto
        ${isLegal ? 'py-6' : 'py-8'}
      `}
    >
      <div
        className={`
          mx-auto px-6
          ${isLegal ? 'max-w-4xl' : 'max-w-7xl'}
        `}
      >
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Company Info */}
          <div className="text-center md:text-left">
            <p className="text-sm text-gray-600">
              © {new Date().getFullYear()} WinGrow. All rights reserved.
            </p>
          </div>

          {/* Legal Links */}
          <nav className="flex flex-wrap justify-center gap-4 md:gap-6">
            <Link
              to="/privacy"
              className="text-sm text-gray-600 hover:text-blue-600 underline transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-gray-600 hover:text-blue-600 underline transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/cookies"
              className="text-sm text-gray-600 hover:text-blue-600 underline transition-colors"
            >
              Cookies Policy
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};
